import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgIntersexGlyphSecondary from './svgs/IntersexGlyphSecondary.js';
import { useIcon } from '../../shared-components/icon/index.js';

var intersexGlyph = (props => useIcon(null, SvgIntersexGlyphSecondary, props));

export { intersexGlyph as default };
